<div class="top-header">
  <div class="position-absolute-fill-left-right d-flex justify-content-between">
    <p>
      {{ (activeProject$ | async)?.name }}
    </p>
    <p class="pr-2 active-sessions-pill">
      <span class="status-dot"></span>
      Active sessions: {{ activeConfigService.activeSessionsCount }}
    </p>
  </div>
</div>
